import { type MouseEvent } from 'react';
import { Option } from '@recargas-dominicanas/core/components';
import { type Style, mergeStyle } from './menu-option.module.css';

interface Props {
  style?: Style;
  text: string;
  disabled?: boolean;
  onClick?: (event?: MouseEvent<HTMLDivElement>) => void;
}

export function MenuOption(props: Props) {

  const {
    text,
    disabled,
    style: customStyle,
    onClick
  } = props;

  const style = mergeStyle(customStyle);

  return (
    <Option
      style={style}
      hiddeIcon={true}
      text={text}
      disabled={disabled}
      onClick={onClick}/>
  );
}
